import { Component, Injector, Input } from "@angular/core";
import { formatDate, formatTime } from '@shared/helpers/data-time-help';
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/app-component-base";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { Moment } from "moment";
import * as moment from "moment";
import { VAGA_CONFIG } from '../vaga-config';

export const MY_FORMATS = VAGA_CONFIG.MY_FORMATS;

@Component({
  selector: "form-publicacao-vaga",
  templateUrl: "./form-publicacao-vaga.component.html",
  styleUrls: ["./form-publicacao-vaga.component.scss"],
  animations: [appModuleAnimation()],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class FormPublicacaoVagaComponent extends AppComponentBase {
  @Input() vaga;
  @Input() view = false;
  @Input() edit = false;

  dataInicioFormatada: string = "";
  horaInicioFormatada: string = "";
  dataTerminoFormatada: string = "";
  horaTerminoFormatada: string = "";
  dataTerminoInscricaoFormatada: string = "";
  horaTerminoInscricaoFormatada: string = "";
  public lancarAgora: boolean = false;

  constructor(
    injector: Injector,
    private dateAdapter: DateAdapter<Moment>
  ) {
    super(injector);
  }

  ngOnInit() {
    this.dateAdapter.setLocale('pt-BR');
    if (this.vaga) {
      this.preencherDatas();
    }
  }

  preencherDatas() {
    if (this.vaga.dataInicio) {
      this.dataInicioFormatada = moment(this.vaga.dataInicio).format('DD/MM/YYYY');
      this.horaInicioFormatada = moment(this.vaga.dataInicio).format('HH:mm');
    } else {
      this.dataInicioFormatada = '';
      this.horaInicioFormatada = '';
    }

    if (this.vaga.dataTermino) {
      this.dataTerminoFormatada = moment(this.vaga.dataTermino).format('DD/MM/YYYY');
      this.horaTerminoFormatada = moment(this.vaga.dataTermino).format('HH:mm');
    } else {
      this.dataTerminoFormatada = '';
      this.horaTerminoFormatada = '';
    }

    if (this.vaga.dataTerminoInscricoes) {
      this.dataTerminoInscricaoFormatada = moment(this.vaga.dataTerminoInscricoes).format('DD/MM/YYYY');
      this.horaTerminoInscricaoFormatada = moment(this.vaga.dataTerminoInscricoes).format('HH:mm');
    } else {
      this.dataTerminoInscricaoFormatada = '';
      this.horaTerminoInscricaoFormatada = '';
    }
  }


  onDateChange(value: string): void {
    if (value.length === 8) {
      const formattedValue = formatDate(value);

      if (moment(formattedValue, 'DD/MM/YYYY', true).isValid()) {
        this.dataInicioFormatada = formattedValue;
        const hora = this.horaInicioFormatada || "00:00";
        this.vaga.dataInicio = moment(`${formattedValue} ${hora}`, 'DD/MM/YYYY HH:mm');
      } else {
        this.vaga.dataInicio = null;
      }
    } else {
      this.vaga.dataInicio = null;
    }
  }

  onTimeChange(value: string): void {
    if (value.length === 4) {
      const formattedValue = formatTime(value);

      if (moment(formattedValue, 'HH:mm', true).isValid()) {
        this.horaInicioFormatada = formattedValue;
        const data = this.dataInicioFormatada || moment().format('DD/MM/YYYY');
        this.vaga.dataInicio = moment(`${data} ${formattedValue}`, 'DD/MM/YYYY HH:mm');
      }
    }
  }

  onDateChangeTermino(value: string): void {
    if (value.length === 8) {
      const formattedValue = formatDate(value);

      if (moment(formattedValue, 'DD/MM/YYYY', true).isValid()) {
        this.dataTerminoFormatada = value;
        const hora = this.horaTerminoFormatada || "00:00";
        this.vaga.dataTermino = moment(`${value} ${hora}`, 'DD/MM/YYYY HH:mm');
      } else {
        this.vaga.dataTermino = null;
      }
    } else {
      this.vaga.dataTermino = null;
    }
  }

  onTimeChangeTermino(value: string): void {
    if (value.length === 4) {
      const formattedValue = formatTime(value);

      if (moment(formattedValue, 'HH:mm', true).isValid()) {
        this.horaTerminoFormatada = formattedValue;
        const data = this.dataTerminoFormatada || moment().format('DD/MM/YYYY');
        this.vaga.dataTermino = moment(`${data} ${formattedValue}`, 'DD/MM/YYYY HH:mm');
      }
    }
  }

  onDateChangeTerminoInscricao(value: string): void {
    if (value.length === 8) {
      const formattedValue = formatDate(value);

      if (moment(formattedValue, 'DD/MM/YYYY', true).isValid()) {
        this.dataTerminoInscricaoFormatada = value;
        const hora = this.horaTerminoInscricaoFormatada || "00:00";
        this.vaga.dataTerminoInscricoes = moment(`${value} ${hora}`, 'DD/MM/YYYY HH:mm');
      } else {
        this.vaga.dataTerminoInscricoes = null;
      }
    } else {
      this.vaga.dataTerminoInscricoes = null;
    }
  }

  onTimeChangeTerminoInscricao(value: string): void {
    if (value.length === 4) {
      const formattedValue = formatTime(value);

      if (moment(formattedValue, 'HH:mm', true).isValid()) {
        this.horaTerminoInscricaoFormatada = formattedValue;
        const data = this.dataTerminoInscricaoFormatada || moment().format('DD/MM/YYYY');
        this.vaga.dataTerminoInscricoes = moment(`${data} ${formattedValue}`, 'DD/MM/YYYY HH:mm');
      } else {
        this.vaga.dataTerminoInscricoes = null;
      }
    }
  }

  updateFilter(option) {
    this.lancarAgora = option;
    if(option){
      this.dataInicioFormatada = moment().format('DD/MM/YYYY');
      this.horaInicioFormatada = moment().format('HH:mm');
      this.vaga.dataInicio = moment(`${this.dataInicioFormatada} ${this.horaInicioFormatada}`, 'DD/MM/YYYY HH:mm');
    }else{
      this.dataInicioFormatada = "";
      this.horaInicioFormatada = "";
      this.vaga.dataInicio = null;
    }
  }
}

